import { useNavigate } from "react-router-dom";
import AsphaltEmission from "../../components/AsphaltEmission/AsphaltEmission";
import "../PageCommon.css";
import "./EmbodiedEmission.css";
import { useEffect } from "react";

const AsphaltEmbodiedEmissionPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
      if (!localStorage.getItem('token')) {
        navigate('/signin');
      }
  }, [navigate]);

  return (
    <div className="page__container">
      <div className="page__body">
          <AsphaltEmission />
      </div>
    </div>
  );
}

export default AsphaltEmbodiedEmissionPage;